import React from 'react'
import { createRoot } from 'react-dom/client';
import Trans from './Trans';

const awardsIcons = [
  {
   filename: "2025/04/Gartner.png", 
   desktopWidth: "150",
   tabletWidth:"140", 
   mobileWidth: "100",
   mobileScaling: "transform scale-105"
  },

  {
   filename: "2025/04/TM_Gold-6-scaled.png", 
   desktopWidth: "155", 
   tabletWidth:"140", 
   mobileWidth: "140",
   mobileScaling: "transform scale-125"
  },

  {
   filename: "2025/05/Brandonhall-TEA.png", 
   desktopWidth: "155",
   tabletWidth:"140", 
   mobileWidth: "140",
   mobileScaling: "transform scale-125"
  },

  {
   filename: "2025/05/Bakers-Dozen-2024.png", 
   desktopWidth: "150",
   tabletWidth:"140", 
   mobileWidth: "100",
   mobileScaling: "transform scale-100"
  },

  {
   filename: "2025/04/EmployeeRecognition_Leader_Small-Business_Leader.webp", 
   desktopWidth: "140",
   tabletWidth:"140", 
   mobileWidth: "100",
   mobileScaling: "transform scale-100"
  },

  {
   filename: "2025/04/EmployeeRecognition_Leader_Mid-Market_Leader.webp", 
   desktopWidth: "140",
   tabletWidth:"140", 
   mobileWidth: "100",
   mobileScaling: "transform scale-100"
  },

  {
    filename: "2025/04/EmployeeRecognition_Leader_Enterprise_Leader.webp", 
    desktopWidth: "140", 
    tabletWidth:"140", 
    mobileWidth: "100",
    mobileScaling: "transform scale-100"
  },

  {
   filename: "2025/04/EmployeeRecognition_Leader_EMEA_Leader.webp", 
   desktopWidth: "140",
   tabletWidth:"140", 
   mobileWidth: "100",
   mobileScaling: "transform scale-100"
  },

  {
   filename: "2025/04/EmployeeRecognition_Leader_AsiaPacific_Leader.webp", 
   desktopWidth: "160",
   tabletWidth:"140", 
   mobileWidth: "100",
   mobileScaling: "transform scale-100"
  }
]

const badgeIcons = [
  "2025/04/EmployeeRecognition_Leader_Small-Business_Leader.webp",
  "2025/04/EmployeeRecognition_Leader_Mid-Market_Leader.webp",
  "2025/04/EmployeeRecognition_Leader_Enterprise_Leader.webp",
  "2025/04/EmployeeRecognition_Leader_EMEA_Leader.webp",
  "2025/04/EmployeeRecognition_Leader_AsiaPacific_Leader.webp"
]

const AwardBadges = () => {
  return (
    <section class="w-full xl:max-w-7xl mx-auto flex flex-col place-items-center z-0 px-2 pt-10 xl:py-16">
        <div class="flex flex-col justify-center items-center bg-white">
            <h2 class="text-gray-500 homepage-section-heading text-center mb-3 text-center max-w-4xl">
               <Trans>Winner of top global awards in Employee Recognition and Engagement</Trans>
            </h2>
              <div className='w-full md:w-10/12 xl:w-full mx-auto grid grid-cols-3 md:grid-cols-4 gap-10 md:gap-16 xl:gap-10 place-content-center mt-10 mb-5'>
                {
                  awardsIcons.map((awardIcon, index) => {
                    return(
                      <div className={index > 3 ? 'flex place-content-center xl:hidden' : 'flex place-content-center'}>
                        <picture className='my-auto'>
                          <source
                            className="z-10 relative"
                            media="(min-width: 1025px)"
                            srcset={`https://res.cloudinary.com/vantagecircle/image/upload/q_auto/gatsbycms/uploads/${awardIcon.filename}`}
                            type="image/webp"
                            alt="Vantage Rewards"
                            width={awardIcon.desktopWidth}
                          />
                          <source
                            className="z-10 relative"
                            srcset={`https://res.cloudinary.com/vantagecircle/image/upload/q_auto/gatsbycms/uploads/${awardIcon.filename}`}
                            type="image/webp"
                            alt="Vantage Rewards"
                            width={awardIcon.tabletWidth}
                          />
                          <img
                            className={`z-10 relative  mx-auto lg:mx-0 ${awardIcon.mobileScaling}`}
                            src={`https://res.cloudinary.com/vantagecircle/image/upload/w_100/q_auto/gatsbycms/uploads/${awardIcon.filename}`}
                            alt="Vantage Rewards"
                            width={awardIcon.mobileWidth}
                          />
                        </picture>
                      </div>
                    )
                  })
                }
              </div>
              <div className='w-full md:w-10/12 xl:w-full mx-auto grid grid-cols-3 md:grid-cols-5 gap-10 md:gap-16 xl:gap-10 place-content-center mt-5 mb-5'>
              {
                badgeIcons.map(awardIcon => {
                  return(
                    <div className='xl:flex hidden place-content-center'>
                      <picture className='my-auto'>
                        <source
                          className="z-10 relative"
                          media="(min-width: 1025px)"
                          srcset={`https://res.cloudinary.com/vantagecircle/image/upload/w_200/q_auto/gatsbycms/uploads/${awardIcon}`}
                          type="image/webp"
                          alt="Vantage Rewards"
                          width="140"
                        />
                        <source
                          className="z-10 relative"
                          srcset={`https://res.cloudinary.com/vantagecircle/image/upload/w_100/q_auto/gatsbycms/uploads/${awardIcon}`}
                          type="image/webp"
                          alt="Vantage Rewards"
                          width="100"
                        />
                        <img
                          className="z-10 relative  mx-auto lg:mx-0"
                          src={`https://res.cloudinary.com/vantagecircle/image/upload/w_80/q_auto/gatsbycms/uploads/${awardIcon}`}
                          alt="Vantage Rewards"
                          width="50"
                        />
                      </picture>
                    </div>
                  )
                })
              }
              </div>
        </div>
    </section>
  )
}

const renderAwardBadges = () => {
    if (typeof window !== "undefined") {
        const id = document.querySelector("#BadgesSection");
        if (id !== null) {
            const root = createRoot(id); // Create a root for rendering
            root.render(<AwardBadges />);
        }
    }
};


setTimeout(renderAwardBadges, 100)

export default AwardBadges